import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    borderRadius: "5px",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("md")]: {
      boxShadow: "none",
      border: 0,
    },
  },
}));
